import React, { useEffect } from "react";
import "./App.css";
import Hero from "./components/Hero";
import { useTracking } from "./hooks/useTracking";

function App() {
  const { shouldRedirect, redirectUrl } = useTracking();

  useEffect(() => {
    if (shouldRedirect && redirectUrl) {
      window.location.href = redirectUrl;
    }

    // Set viewport meta tag once on mount
    if (!document.querySelector('meta[name="viewport"]')) {
      const metaViewport = document.createElement("meta");
      metaViewport.name = "viewport";
      metaViewport.content =
        "width=device-width, initial-scale=1, maximum-scale=1";
      document.head.appendChild(metaViewport);
    }
  }, [shouldRedirect, redirectUrl]);

  return <Hero />;
}

export default App;